import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMPTY_LIST = [];
const EMPTY_OBJ = {};
const store = {};

// Public data fetched once per page load and shared by navbar, footer and pages.
function useCached(path, empty) {
  const [data, setData] = useState(store[path]?.data || empty);

  useEffect(() => {
    const entry = (store[path] = store[path] || {});
    if (entry.data) return;
    entry.pending = entry.pending || axios.get(`${API}${path}`)
      .then(r => { entry.data = r.data || empty; return entry.data; })
      .catch(() => { entry.pending = null; return empty; });
    let active = true;
    entry.pending.then(d => { if (active) setData(d); });
    return () => { active = false; };
  }, [path, empty]);

  return data;
}

export const useServices = () => useCached('/services', EMPTY_LIST);
export const useRegions = () => useCached('/regions', EMPTY_LIST);
export const useSettings = () => useCached('/settings', EMPTY_OBJ);

export const regionPath = (region) => `/einsatzgebiete/${region.slug || region.key}`;

export const localized = (item, field, language) => item?.[`${field}_${language}`] || item?.[`${field}_de`] || '';

export const localizedList = (item, field, language) => {
  const list = item?.[`${field}_${language}`];
  return list && list.length ? list : item?.[`${field}_de`] || [];
};
